import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {AfterViewInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {

  activeCourse:boolean=true;
  succesCourse:boolean=false;

  searchText = ""; is_active = "1"; order_by = ""; order = "asc";
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }

  userData: any; filter_by: any = ""; status:string="1"
  user_id:any;
  course_id:any;assessment_id:any; request_status:number=1;
  tabName: any;
  submitted = false;
  reject_reason: string="";
  adminData:any;
  tcktCount:number=0;
  resetRqstCount:number=0;

  // rejectForm = new FormGroup({
  //   txtRemark: new FormControl('',[Validators.required] ),
  // });
  
  // get f() { return this.rejectForm.controls; } 

  constructor(private modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService) {}

  // open(content: any) {
  //   this.modalService.open(content, { centered: true, size: 'sm' });
  // }
  ngOnInit(): void {
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
    this.getUserList(this.searchText, this.order_by, this.order, this.status);
  }
  
  onSelectChange(event: any) {
    if (event.index == 0) { //Pending
      this.status = '1';
    } else  if(event.index == 1){
      this.status = '2'; //active
    }
    else{
      this.status = '3'; //rejected
    }
    this.getUserList(this.searchText, this.order_by, this.order, this.status);
  }
  
  getUserList(searchText: any, order_by: any, order: any, status: any) {
    this.spinner.show();
    this.contentAuthoringApi.getResetRqstList(searchText, order_by, order, status).subscribe(
      (data) => {
        if (data.success) {
          this.userData = data.courseData.userlist;
        } else {
         // this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
 
  search(event: any) {
    this.searchText = event.target.value;
    this.getUserList(this.searchText, this.order_by, this.order, this.status);
  }
  getTicketCount() {
    const jsonPost={
      email: this.adminData.email
    }
    this.contentAuthoringApi.ticketCountDetail(jsonPost).subscribe(
      (data) => {
        if (data.success) {
          this.tcktCount= data.ticket_count;
          this.resetRqstCount= data.reset_req_count
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist';
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }

  sortData(sort: any) {
    if (sort.direction == 'desc') {
     // this.order_by = sort.active; this.order = 'asc';
      this.order = sort.active; this.order_by = 'asc';
    } else if (sort.direction == 'asc') {
      //this.order_by = sort.active; this.order = 'asc';
      this.order = sort.active; this.order_by = 'asc';
    } else { this.order = 'end_date'; this.order_by = 'desc'; }
    // this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
    this.getUserList(this.searchText, this.order_by, this.order, this.status);
  }
  /*****click on logout button function ******/
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  openAccept(content: any, data:any) { 
    console.log(data);
    this.user_id = data.user_id
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.request_status=2
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
  acceptRejectCourses(user_id:number,course_id:any,assessment_id:any, request_status:any, reject_reason:any){
    this.spinner.show();
    this.contentAuthoringApi.ViewCoursesAcceptReject(user_id,course_id,assessment_id, request_status, reject_reason).subscribe(
      data=>{
       console.log(data)
       this.getTicketCount()
        this.spinner.hide();
      },error=>{
        this.spinner.hide();
      }
    )
  }
  openReject(content: any, data:any) { 
    console.log(data);
    this.user_id = data.user_id
    this.course_id=data.course_id
    this.assessment_id= data.assessment_id,
    this.request_status=3
    this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' }); 

  }
//   onSubmit(rejectForm: any) {

//     this.submitted = true;
//     if(this.rejectForm.invalid) { this.spinner.hide(); return; }
//     this.reject_reason= this.rejectForm.controls.txtRemark.value;
//     this.acceptRejectCourses(this.user_id,this.course_id,this.assessment_id, this.request_status, this.reject_reason)
//     this.rejectForm.reset();
//     this.modalService.dismissAll();
//    // this.router.navigateByUrl('/reset',)
//     this.redirectTo('/reset');
//    }
//    redirectTo(uri:string){
//     this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
//     this.router.navigate([uri]));
//  }
}





